import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { brianUrlacher } from "@/lib/celebrity-results/brian-urlacher";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Brian Urlacher Hair Transplant Results | RESTORE Hair";
const DESC = "Brian Urlacher was known for being bald until he came to RESTORE to get his hair back. Watch & learn about Brian Urlacher's hair story before & after RESTORE.";
// Parity options. The h1 stays "Brian Urlacher's Hair Restoration Story with RESTORE".
const WP = {};
const POSTER = "/img/r/wp-2024-07-brainurlacherposter1-e1723148455769.webp";

export const Route = createFileRoute("/results/brian-urlacher")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/brian-urlacher/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/brian-urlacher/" },
    ],
  }),
  component: () => <CelebrityResultPage data={brianUrlacher} wp={WP} />,
});
